import React, {useContext} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {
  MenuItem,
  SidebarMenuGroupButton,
  SidebarNew,
  SidebarNewInline
} from './styles';
import ClosableSidebarButton from './ClosableSidebarButton';
import SidebarVariantContext from './SidebarVariantContext';

const SidebarMenuItem = ({
  icon,
  text,
  route,
  feature,
  extraNewTagDisplayLogic = () => true,
  closeSidebarEvent,
  activeClassName = 'isActive',
  subItems,
  arrowIcon,
  isGroup,
  isActive,
  onClick
}) => {
  const variant = useContext(SidebarVariantContext);
  const featureItems = useSelector(
    (state) => state.user.userData?.featureItems
  );

  const isAllowedFeature = featureItems.find(
    (item) => item.id === feature && item.isNewFeature
  );
  const showNewTag = Boolean(isAllowedFeature) && extraNewTagDisplayLogic();
  // Nav v2 puts the tag right after the label; the control sidebar keeps it on the right edge.
  const isInlineNewTag = variant === 'test';

  if (isGroup) {
    return (
      <MenuItem>
        <SidebarMenuGroupButton
          type='button'
          className={cn({isActive})}
          onClick={onClick}
        >
          {icon}
          <span>
            {text}
            {arrowIcon}
          </span>
        </SidebarMenuGroupButton>
        {subItems}
      </MenuItem>
    );
  }

  const trackClick = () => {
    window?.posthog?.capture?.('sidebar_item_clicked', {
      item_name: text,
      item_route: route,
      variant
    });
  };

  return (
    <MenuItem>
      <ClosableSidebarButton
        closeSidebar={closeSidebarEvent}
        activeClassName={subItems ? 'isDisabled' : activeClassName}
        to={route}
        dataPhClick='sidebar'
        dataLabel={text}
        dataRoute={route}
        onClick={trackClick}
      >
        {icon}
        <span>
          {text}
          {showNewTag && isInlineNewTag && (
            <SidebarNewInline as='span'>New</SidebarNewInline>
          )}
          {arrowIcon}
        </span>
        {showNewTag && !isInlineNewTag && <SidebarNew>New</SidebarNew>}
      </ClosableSidebarButton>
      {subItems}
    </MenuItem>
  );
};

SidebarMenuItem.propTypes = {
  icon: PropTypes.element,
  text: PropTypes.string.isRequired,
  activeClassName: PropTypes.string,
  route: PropTypes.string,
  feature: PropTypes.string,
  extraNewTagDisplayLogic: PropTypes.func,
  closeSidebarEvent: PropTypes.func,
  subItems: PropTypes.element,
  arrowIcon: PropTypes.element,
  isGroup: PropTypes.bool,
  isActive: PropTypes.bool,
  onClick: PropTypes.func
};

SidebarMenuItem.defaultProps = {
  extraNewTagDisplayLogic: () => true,
  activeClassName: 'isActive',
  closeSidebarEvent: () => {},
  route: '',
  subItems: null,
  arrowIcon: null,
  feature: '',
  icon: null,
  isGroup: false,
  isActive: false,
  onClick: undefined
};

export default SidebarMenuItem;
